var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.resolveLayoutVariant,{tag:"component"},[_c('LoadingOverlay',{attrs:{"loading":_vm.app.isLoadingOverlay}}),_c('v-slide-x-transition',{attrs:{"mode":"out-in"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }